// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from "./components/layouts/NavBar"
import Home from './pages/Home';
import Shop from './pages/Shop';
import AboutUs from './pages/AboutUs';
import Login from './pages/Login';
import Footer from './components/layouts/Footer';
import WhatsAppBox from './components/WhatsAppBox';
import Toast from './components/Toast';
import ShoppingCart from './components/ShoppingCart';
import './App.css';
import Register from "./pages/Register";
import TermAndConditions from "./pages/TermAndConditions";
import ProtectedRoute from "./components/ProtectedRoute";
import CartCheckout from "./pages/CartCheckout";
import PaymentPage from './pages/PaymentPage';
import PaymentConfirmation from './pages/PaymentConfirmation';
import Profile from "./pages/Profile";
import Order from "./pages/Order";

function ScrollToTop() {
    const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
    return null;
  }

function App() {
    const [toast, setToast] = useState({ show: false, message: '' });

    const showToast = (message = 'Item Added') => {
        setToast({ show: true, message });
    };

    const hideToast = () => {
        setToast({ show: false, message: '' });
    };

    return (
        <Router>
            <ScrollToTop />
            <div className="App">
                <Navbar showToast={showToast} />
                <Routes>
                    <Route path="/" element={<Home showToast={showToast} />} />
                    <Route path="/shop" element={<Shop showToast={showToast} />} />
                    <Route path="/aboutus" element={<AboutUs />} />
                    <Route path="/payment" element={<PaymentPage />} />
                    <Route path="/payment/confirmation" element={<PaymentConfirmation />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/termsandconditions" element={<TermAndConditions />} />
                    <Route path="/cartcheckout" element={<ProtectedRoute>
                  <CartCheckout showToast={showToast} />
                </ProtectedRoute>}/>
                    <Route path="/profile" element={<ProtectedRoute>
                  <Profile />
                </ProtectedRoute>}/>
                    <Route path="/orders" element={<ProtectedRoute>
                  <Order />
                </ProtectedRoute>}/>
                </Routes>
                <Footer />
                <WhatsAppBox />
                <ShoppingCart showToast={showToast} />
                <Toast message={toast.message} show={toast.show} onHide={hideToast} />
            </div>
        </Router>
    );
}

export default App;